// Condition thumbnails, keyed by the category id the API returns.
//
// Sliced from the supplied 4x3 contact sheet (kept in design/) and re-encoded
// to WebP: 798KB of PNG became 45KB for the set.
//
// Keyed by id rather than by name so renaming a condition in the CMS doesn't
// silently drop its artwork. A category with no entry here simply renders
// without a thumbnail — see CategoryGrid — so adding conditions never breaks
// the grid, it just leaves them plain until artwork exists.

import addictionRecovery from './addiction-recovery.webp';
import adhd from './adhd.webp';
import anxietyTreatment from './anxiety-treatment.webp';
import burnoutStress from './burnout-stress.webp';
import depression from './depression.webp';
import eatingDisorders from './eating-disorders.webp';
import griefLoss from './grief-loss.webp';
import ocd from './ocd.webp';
import relationships from './relationships.webp';
import selfEsteem from './self-esteem.webp';
import sleepProblems from './sleep-problems.webp';
import traumaPtsd from './trauma-ptsd.webp';

const CONDITION_THUMBNAILS = {
  1: anxietyTreatment,
  2: depression,
  3: traumaPtsd,
  4: relationships,
  5: adhd,
  6: griefLoss,
  7: burnoutStress,
  8: eatingDisorders,
  9: ocd,
  10: addictionRecovery,
  11: sleepProblems,
  12: selfEsteem,
};

export default CONDITION_THUMBNAILS;
